import React from 'react';
import { MailIcon, ArrowLeftIcon, Building2Icon, MapIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function InvestorDeckPage() {
  return <div className="min-h-screen bg-gray-50 font-sans text-[#111111]" data-id="element-1633">
      {/* Private Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-1634">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-1635">
          <div className="flex items-center space-x-4" data-id="element-1636">
            <Link to="/" className="text-gray-500 hover:text-[#631bb7] transition-colors" data-id="element-1637">
              <ArrowLeftIcon size={20} data-id="element-1638" />
            </Link>
            <div className="h-6 w-px bg-gray-200" data-id="element-1639"></div>
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-6" data-id="element-1640" />
            <span className="bg-gray-100 text-gray-600 text-xs font-semibold px-2 py-1 rounded-full uppercase tracking-wide" data-id="element-1641">
              Investor Portal
            </span>
          </div>
          <div className="text-sm text-gray-500" data-id="element-1642">
            Confidential & Proprietary
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-16 space-y-16" data-id="element-1643">
        {/* Welcome / Hero */}
        <section className="text-center max-w-3xl mx-auto" data-id="element-1644">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-[#111111]" data-id="element-1645">
            Welcome to the
            <br data-id="element-1646" />
            Caveo Investor Portal
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-1647">
            Access our strategic overview and product roadmap as we redefine
            family digital safety.
          </p>
        </section>

        {/* Portal Hub Cards */}
        <section className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1648">
          <Link to="/investor-overview" className="group bg-white rounded-2xl p-8 border border-gray-200 shadow-sm hover:shadow-md hover:border-[#631bb7] transition-all flex flex-col items-center text-center no-underline" data-id="element-1649">
            <div className="w-16 h-16 bg-[#f0ebf8] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-1650">
              <Building2Icon size={32} className="text-[#631bb7]" data-id="element-1651" />
            </div>
            <h2 className="text-2xl font-bold text-[#111111] mb-3" data-id="element-1652">
              Company Overview
            </h2>
            <p className="text-gray-600" data-id="element-1653">
              Our mission, market opportunity, and strategic positioning.
            </p>
          </Link>

          <Link to="/investor-roadmap" className="group bg-white rounded-2xl p-8 border border-gray-200 shadow-sm hover:shadow-md hover:border-[#631bb7] transition-all flex flex-col items-center text-center no-underline" data-id="element-1654">
            <div className="w-16 h-16 bg-[#f0ebf8] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-1655">
              <MapIcon size={32} className="text-[#631bb7]" data-id="element-1656" />
            </div>
            <h2 className="text-2xl font-bold text-[#111111] mb-3" data-id="element-1657">
              Product Roadmap
            </h2>
            <p className="text-gray-600" data-id="element-1658">
              Product strategy, feature roadmap, and development timeline.
            </p>
          </Link>
        </section>

        {/* Contact */}
        <section className="bg-white rounded-2xl p-8 md:p-12 border border-gray-200 text-center max-w-4xl mx-auto" data-id="element-1659">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1660">
            Questions or Due Diligence Requests?
          </h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-1661">
            We're happy to provide additional data room access or schedule a
            deep dive into our product roadmap and go-to-market strategy.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1662">
            <a href="mailto:jbp@caveohq.com" className="inline-flex items-center justify-center bg-[#111111] text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors" data-id="element-1663">
              <MailIcon size={18} className="mr-2" data-id="element-1664" />
              Email Us
            </a>
            <a href="https://calendar.app.google/EnoqEH7z4cY89jjN8" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-white border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors" data-id="element-1665">
              Book a Meeting
            </a>
          </div>
        </section>
      </main>

      <footer className="bg-white border-t border-gray-200 py-8 mt-auto" data-id="element-1666">
        <div className="max-w-7xl mx-auto px-6 text-center text-sm text-gray-500" data-id="element-1667">
          <p data-id="element-1668">&copy; 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.</p>
          <p className="mt-2 text-xs text-gray-400" data-id="element-1669">
            This page contains confidential information intended only for
            authorized investors. Do not share or distribute without permission.
          </p>
        </div>
      </footer>
    </div>;
}